enum ClientGroupId {
  ADULTS = 1,
  ELDERLY = 2,
  CHILDREN = 3,
}

export default ClientGroupId
